import get from "lodash/get";
import isNil from "lodash/isNil";
import last from "lodash/last";
import map from "lodash/map";
import split from "lodash/split";
export const formatSize = (bytes, decimals = 2) => {
    if (isNil(bytes))
        return "";
    if (bytes === 0)
        return "0 B";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
export function dataURLtoFile(data, name) {
    const arr = split(data === null || data === void 0 ? void 0 : data.toString(), ",");
    const mime = get(arr[0].match(/:(.*?);/), "[1]");
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], name, { type: mime });
}
export function getArrayDataUrlToFile(array) {
    return map(array, item => dataURLtoFile(item.data, item.name));
}
export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
export function getExtensionFileFromName(name) {
    if (name) {
        const parsedName = split(name, ".");
        const result = (parsedName.length && last(parsedName)) || "";
        return result;
    }
    return "";
}
